import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '@reusable/services/shared.service';
import { NotificationCustomerService } from '../../services/notification.customer.service';

@Component({
  selector: 'app-notifcations',
  standalone: false,
  templateUrl: './notifcations.component.html',
  styleUrls: ['./notifcations.component.scss']

})
export class NotifcationsComponent implements OnInit {
  notifications: any[];
  @Input() headerItem = false;
  constructor(private ns: NotificationCustomerService, private data: SharedService) {}

  ngOnInit() {
    this.data.changeMessage('notifications');
    this.ns.listNotifications().subscribe((res: any) => {
      this.notifications = res.notification;
      if (this.notifications?.length) {
        this.notifications.forEach(notification => {
          notification.notificationLink = this.notificationLinkGenerator(notification);
        });
      }
    });
  }

  notificationLinkGenerator(notification: any): string {
    let finalLink = '';
    if (notification.requestId) {
      return (finalLink = `/home/requests/view-request/${notification.requestId}`);
    }
    if (notification.orderId) {
      // return (finalLink = `/home/orders/view/${notification.orderId}`);
    }
    if (notification.carId) {
      return (finalLink = '/home/profile/');
    }

    return finalLink;
  }
}